export const environment = {
    production: true,
    apiUrl:'https://tfact.pspldemo.in/api/v1/client/',
    // apiUrl:'https://127.0.0.1:8000/api/v1/client/',
    mediaBaseUrl:'https://tfact.pspldemo.in/storage/',
    firebase: {
        apiKey: "AIzaSyAaMCdRirHbH-zeEdN-ZQzL-NYD_V1hM0E",
        authDomain: "teacherfactory-a6377.firebaseapp.com",
        databaseURL: "https://teacherfactory-a6377-default-rtdb.firebaseio.com",
        projectId: "teacherfactory-a6377",
        storageBucket: "teacherfactory-a6377.firebasestorage.app",
        messagingSenderId: "142405532372",
        appId: "1:142405532372:web:d59a5be213d54b744b1941",
        measurementId: "G-YK57120YCN"
    }
};

